import { default as ShopCommissions } from './ShopCommissions';
import ShopCommissionsContainer from './ShopCommissions.container';

export default ShopCommissionsContainer(ShopCommissions);
